<!-- 平台管理端 — 店铺管理列表 -->
<template>
  <!-- 搜索栏 -->
  <ContentWrap>
    <el-form :inline="true" :model="queryParams" class="-mb-15px">
      <el-form-item label="店铺名称">
        <el-input
          v-model="queryParams.shopName"
          placeholder="请输入店铺名称"
          clearable
          class="!w-200px"
          @keyup.enter="getList"
        />
      </el-form-item>
      <el-form-item label="店铺类型">
        <el-select v-model="queryParams.shopType" clearable placeholder="全部" class="!w-140px">
          <el-option label="第三方入驻" :value="0" />
          <el-option label="平台自营" :value="1" />
          <el-option label="酒店" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="queryParams.status" clearable placeholder="全部" class="!w-120px">
          <el-option label="营业中" :value="1" />
          <el-option label="已冻结" :value="2" />
          <el-option label="已关闭" :value="4" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="getList">
          <Icon class="mr-5px" icon="ep:search" />搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />重置
        </el-button>
        <el-button
          type="primary"
          plain
          v-hasPermi="['merchant:shop:create']"
          @click="openCreateDialog"
        >
          <Icon icon="ep:plus" class="mr-5px" />新增自营店铺
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="店铺ID" width="80" prop="id" />
      <el-table-column label="店铺名称" min-width="160" prop="shopName" show-overflow-tooltip />
      <el-table-column label="店铺Logo" width="90">
        <template #default="{ row }">
          <el-image
            v-if="row.shopLogo"
            :src="row.shopLogo"
            class="h-40px w-40px rounded-6px"
            fit="cover"
          />
          <span v-else class="text-gray-400">-</span>
        </template>
      </el-table-column>
      <el-table-column label="店铺类型" width="110">
        <template #default="{ row }">
          <el-tag :type="shopTypeTagType(row.shopType)">{{ shopTypeLabel(row.shopType) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" width="130" prop="contactPhone" />
      <el-table-column label="评分" width="80" prop="score" />
      <el-table-column label="状态" width="90">
        <template #default="{ row }">
          <el-tag :type="shopStatusTagType(row.shopStatus)">{{ shopStatusLabel(row.shopStatus) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="170" prop="createTime" :formatter="dateFormatter" />
      <el-table-column label="操作" width="320" fixed="right">
        <template #default="{ row }">
          <el-button
            type="primary"
            link
            v-hasPermi="['merchant:shop:update']"
            @click="openProfileDialog(row)"
          >
            编辑形象
          </el-button>
          <template v-if="!selfUiScope">
            <el-button
              v-if="row.shopType !== 3"
              type="warning"
              link
              v-hasPermi="['merchant:shop:update']"
              @click="handleUpdateType(row, 3)"
            >
              标为酒店
            </el-button>
            <template v-else>
              <el-button
                type="primary"
                link
                v-hasPermi="['merchant:shop:update']"
                @click="handleUpdateType(row, 0)"
              >
                改回第三方
              </el-button>
              <el-button
                type="success"
                link
                v-hasPermi="['merchant:shop:update']"
                @click="handleUpdateType(row, 1)"
              >
                改回自营
              </el-button>
            </template>
          </template>
          <template v-if="isShopActive(row.shopStatus)">
            <el-button type="danger" link @click="handleUpdateStatus(row, 4)">关店</el-button>
          </template>
          <template v-else-if="row.shopStatus === 4 || row.shopStatus === 20">
            <el-button type="success" link @click="handleUpdateStatus(row, 1)">启用</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <!-- 新增自营店铺弹窗 -->
  <el-dialog v-model="dialogVisible" title="新增平台自营店铺" width="560px">
    <el-alert
      type="info"
      :closable="false"
      show-icon
      class="mb-16px"
      title="只创建店铺壳（平台自营），不创建商家登录账号。"
      description="不能用来登录商家中心。外部商家请走「入驻审核」。挂货：商品管理 → 添加/修改商品 → 选择所属自营店铺。"
    />
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="店铺名称" prop="shopName">
        <el-input v-model="form.shopName" placeholder="请输入店铺名称" maxlength="100" />
      </el-form-item>
      <el-form-item label="店铺Logo" prop="shopLogo">
        <UploadImg v-model="form.shopLogo" width="100px" height="100px" directory="shop/logo" />
        <div class="form-tip">C 端店铺头像</div>
      </el-form-item>
      <el-form-item label="店铺头图" prop="shopBanner">
        <UploadImg v-model="form.shopBanner" width="240px" height="100px" directory="shop/banner" />
        <div class="form-tip">C 端顶部背景，建议宽图约 750×300</div>
      </el-form-item>
      <el-form-item label="店铺简介" prop="shopDesc">
        <el-input
          v-model="form.shopDesc"
          type="textarea"
          :rows="3"
          placeholder="请输入店铺简介"
          maxlength="1000"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="联系电话" prop="contactPhone">
        <el-input v-model="form.contactPhone" placeholder="请输入联系电话" maxlength="20" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleCreate">确定</el-button>
    </template>
  </el-dialog>

  <!-- 编辑店铺形象 -->
  <el-dialog v-model="profileVisible" title="编辑店铺形象" width="560px">
    <el-form ref="profileFormRef" :model="profileForm" :rules="rules" label-width="100px">
      <el-form-item label="店铺名称" prop="shopName">
        <el-input v-model="profileForm.shopName" placeholder="请输入店铺名称" maxlength="100" />
      </el-form-item>
      <el-form-item label="店铺Logo">
        <UploadImg
          v-model="profileForm.shopLogo"
          width="100px"
          height="100px"
          directory="shop/logo"
        />
        <div class="form-tip">C 端店铺头像；清空后显示店名首字</div>
      </el-form-item>
      <el-form-item label="店铺头图">
        <UploadImg
          v-model="profileForm.shopBanner"
          width="240px"
          height="100px"
          directory="shop/banner"
        />
        <div class="form-tip">C 端顶部背景；清空后显示品牌渐变</div>
      </el-form-item>
      <el-form-item label="店铺简介">
        <el-input
          v-model="profileForm.shopDesc"
          type="textarea"
          :rows="3"
          placeholder="请输入店铺简介"
          maxlength="1000"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="profileForm.contactPhone" placeholder="请输入联系电话" maxlength="20" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="profileVisible = false">取消</el-button>
      <el-button type="primary" :loading="profileSubmitting" @click="handleSaveProfile">
        保存
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { dateFormatter } from '@/utils/formatTime'
import {
  getShopPage,
  createSelfOperatedShop,
  updateShopStatus,
  updateShopType,
  updateShopProfile
} from '@/api/merchant/shop-manager'
import { ContentWrap } from '@/components/ContentWrap'
import { UploadImg } from '@/components/UploadFile'
import { useMallSelfPlatformOnlyGuard } from '@/hooks/web/useMallSelfPlatformOnlyGuard'

defineOptions({ name: 'MerchantShopManager' })

const { isSelfScope, guardPlatformOnlyPage } = useMallSelfPlatformOnlyGuard()
/** 自营视角：禁止改店铺类型（含改回第三方） */
const selfUiScope = computed(() => isSelfScope())
const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  shopName: '',
  shopType: undefined as number | undefined,
  status: undefined as number | undefined
})

function isShopActive(status?: number) {
  return status === 1 || status === 10
}

function shopStatusLabel(status?: number) {
  const map: Record<number, string> = {
    0: '未激活',
    1: '营业中',
    2: '已冻结',
    3: '关店中',
    4: '已关闭',
    10: '营业中',
    20: '已关闭'
  }
  return map[status as number] || `状态#${status}`
}

function shopStatusTagType(status?: number) {
  if (isShopActive(status)) return 'success'
  if (status === 2) return 'warning'
  return 'danger'
}

function shopTypeLabel(shopType?: number) {
  const map: Record<number, string> = {
    0: '第三方入驻',
    1: '平台自营',
    2: 'O2O机构壳',
    3: '酒店'
  }
  return map[shopType as number] || '第三方入驻'
}

function shopTypeTagType(shopType?: number) {
  if (shopType === 1) return 'success'
  if (shopType === 3) return 'warning'
  return 'info'
}

const dialogVisible = ref(false)
const submitting = ref(false)
const formRef = ref()
const form = reactive({
  shopName: '',
  shopLogo: '',
  shopBanner: '',
  shopDesc: '',
  contactPhone: ''
})
const rules = {
  shopName: [{ required: true, message: '请输入店铺名称', trigger: 'blur' }]
}

const profileVisible = ref(false)
const profileSubmitting = ref(false)
const profileFormRef = ref()
const profileForm = reactive({
  id: 0,
  shopName: '',
  shopLogo: '',
  shopBanner: '',
  shopDesc: '',
  contactPhone: ''
})

async function getList() {
  loading.value = true
  try {
    const data = await getShopPage(queryParams)
    list.value = data?.list ?? []
    total.value = data?.total ?? 0
  } finally {
    loading.value = false
  }
}

function resetQuery() {
  queryParams.shopName = ''
  queryParams.shopType = undefined
  queryParams.status = undefined
  queryParams.pageNo = 1
  getList()
}

function openCreateDialog() {
  form.shopName = ''
  form.shopLogo = ''
  form.shopBanner = ''
  form.shopDesc = ''
  form.contactPhone = ''
  dialogVisible.value = true
}

function openProfileDialog(row: any) {
  profileForm.id = row.id
  profileForm.shopName = row.shopName || ''
  profileForm.shopLogo = row.shopLogo || ''
  profileForm.shopBanner = row.shopBanner || ''
  profileForm.shopDesc = row.shopDesc || ''
  profileForm.contactPhone = row.contactPhone || ''
  profileVisible.value = true
}

async function handleCreate() {
  const valid = await formRef.value?.validate().catch(() => false)
  if (!valid) return
  submitting.value = true
  try {
    await createSelfOperatedShop(form)
    ElMessage.success('自营店铺创建成功')
    dialogVisible.value = false
    getList()
  } finally {
    submitting.value = false
  }
}

async function handleSaveProfile() {
  const valid = await profileFormRef.value?.validate().catch(() => false)
  if (!valid) return
  profileSubmitting.value = true
  try {
    await updateShopProfile({
      id: profileForm.id,
      shopName: profileForm.shopName,
      shopLogo: profileForm.shopLogo ?? '',
      shopBanner: profileForm.shopBanner ?? '',
      shopDesc: profileForm.shopDesc ?? '',
      contactPhone: profileForm.contactPhone ?? ''
    })
    ElMessage.success('店铺形象已保存')
    profileVisible.value = false
    getList()
  } finally {
    profileSubmitting.value = false
  }
}

async function handleUpdateStatus(row: any, status: number) {
  const action = status === 4 ? '关闭' : '启用'
  try {
    await ElMessageBox.confirm(`确定要${action}店铺"${row.shopName}"吗？`, '操作确认', {
      type: 'warning'
    })
    await updateShopStatus({ id: row.id, status })
    ElMessage.success(`已${action}`)
    getList()
  } catch {
    // cancelled
  }
}

async function handleUpdateType(row: any, shopType: number) {
  if (selfUiScope.value) {
    ElMessage.warning('自营视角不可变更店铺类型')
    return
  }
  const actionMap: Record<number, string> = {
    0: '改回第三方入驻（将重新进入商城 feed）',
    1: '改回平台自营（将重新进入商城 feed）',
    3: '标为酒店（其商品将从商城 feed 排除）'
  }
  const action = actionMap[shopType] || '更新类型'
  try {
    await ElMessageBox.confirm(`确定将店铺「${row.shopName}」${action}吗？`, '操作确认', {
      type: 'warning'
    })
    await updateShopType({ id: row.id, shopType })
    ElMessage.success('类型已更新')
    getList()
  } catch {
    // cancelled
  }
}

onMounted(() => {
  if (guardPlatformOnlyPage()) {
    return
  }
  getList()
})
</script>

<style scoped>
.form-tip {
  margin-top: 6px;
  font-size: 12px;
  color: var(--el-text-color-secondary);
  line-height: 1.4;
}
</style>
